import { render, staticRenderFns } from "./OurServiceMain.vue?vue&type=template&id=21e87443&scoped=true"
import script from "./OurServiceMain.vue?vue&type=script&lang=js"
export * from "./OurServiceMain.vue?vue&type=script&lang=js"
import style0 from "./OurServiceMain.vue?vue&type=style&index=0&id=21e87443&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e87443",
  null
  
)

export default component.exports